(() => {
  class QuestionnaireListController {
    constructor($stateParams, toastr, Services, QuestionnaireService, Utils) {
      'ngInject';

      Object.assign(this, {
        toastr,
        QuestionnaireService,
        Services,
        Utils,
        serviceId: $stateParams.serviceId
      });
    }

    $onInit() {
      this.Services.fetch(this.serviceId)
        .then(({ data: service }) => {
          this.service = service;
          return this.QuestionnaireService.list(this.service.code);
        })
        .then(({ data }) => {
          const { pagination, data: questionnaires } = data;

          this.questionnaires = questionnaires.map(q => new Questionnaire(q, this.service));
          this.pagination = pagination;
        })
        .catch((err) => {
          return this.toastr.error(this.Utils.getApiErrorMessage(err, 'Could not update questionnaire phase.'));
        });
    }
  }

  QuestionnaireListController.$inject = ["$stateParams", "toastr", "Services", "QuestionnaireService", "Utils"];
  angular.module('pims').component('questionnaires', {
    templateUrl: 'app/views/services/questionnaire/questionnaire.list.html',
    controller: QuestionnaireListController,
    bindings: {
      service: '<',
      products: '<',
    },
  });
})();
